export const RESUME_ROUTES = {
	builder: "/app/me/resume",
} as const;
